/**
 * Points Currency i18n Translations
 */

export const pointsTranslations = {
  en: {
    'points.balance': 'Points Balance',
    'points.earned': 'Earned from referrals',
    'points.currency': 'Points',
    'points.symbol': 'pts',
    'points.createToken': 'Create Points Token',
    'points.sendPoints': 'Send Points',
    'points.receivePoints': 'Receive Points',
    'points.transactionHistory': 'Points Transaction History',
    'points.earnFromReferrals': 'Earn Points from Referrals',
    'points.referralReward': 'Referral Reward',
  },
  fr: {
    'points.balance': 'Solde de Points',
    'points.earned': 'Gagné grâce aux parrainages',
    'points.currency': 'Points',
    'points.symbol': 'pts',
    'points.createToken': 'Créer un Token de Points',
    'points.sendPoints': 'Envoyer des Points',
    'points.receivePoints': 'Recevoir des Points',
    'points.transactionHistory': 'Historique des Transactions de Points',
    'points.earnFromReferrals': 'Gagner des Points grâce aux Parrainages',
    'points.referralReward': 'Récompense de Parrainage',
  },
};

